module.exports = __webpack_public_path__ + "img/title14.65df6bb8.png";